import { Role } from "../../types/role";

const BBMun: Role = {
  primary: [
    "Passen",
    "Tackling",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Technik",
    "Weitschuesse",
    "Aggressivitaet",
    "Antizipation",
    "Entscheidungen",
    "Nervenstaerke",
    "Stellungsspiel",
    "Antritt",
    "Balance",
    "Kraft",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};

export const BBM = {
  BBMun,
};
